import React from 'react';
import { M06SelectCustomerScreen } from './M06SelectCustomerScreen';

export { M06SelectCustomerScreen };

/**
 * Backwards-compatible route component for M06InputCustomerScreen (Step 1: Input Customer Info)
 */
export const M06InputCustomerScreen: React.FC = () => {
  return <M06SelectCustomerScreen />;
};
